import { render } from "./ForkDialog.vue?vue&type=template&id=14d0a1f0&scoped=true"
import script from "./ForkDialog.vue?vue&type=script&lang=js"
export * from "./ForkDialog.vue?vue&type=script&lang=js"

import "./ForkDialog.vue?vue&type=style&index=0&id=14d0a1f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d0a1f0"]])

export default __exports__